import { render } from "./AffectedItemsTable.vue?vue&type=template&id=2813a536&scoped=true"
import script from "./AffectedItemsTable.vue?vue&type=script&lang=js"
export * from "./AffectedItemsTable.vue?vue&type=script&lang=js"

import "./AffectedItemsTable.vue?vue&type=style&index=0&id=2813a536&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2813a536"]])

export default __exports__